import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { UserPlus, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaProfissionalAtribuido = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('atribuiu profissional') && !acaoLower.includes('alterou profissional');
};

const getIconProfissionalAtribuido = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: UserPlus, color: 'var(--c8041c7)' };
};

export default function CardProfissionalAtribuido({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconProfissionalAtribuido(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
        />
    );
}

export const profissionalAtribuidoConfig = {
    tipo: 'profissional_atribuido',
    detectaTipo: detectaProfissionalAtribuido,
    getIcon: getIconProfissionalAtribuido,
    temExpansao: () => true,
    Component: CardProfissionalAtribuido
};

